import React, { Component } from 'react'

class NoCase extends Component {
    render() {
        return (
            <div className="container heading-center">
                <h4 className="text-success">No cases yet!</h4>
            </div>
        )
    }
}

export default NoCase
